import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { SalService } from 'src/app/Services/sal/sal.service';

@Component({
  selector: 'app-create-order',
  templateUrl: './create-order.component.html',
  styleUrls: ['./create-order.component.css']
})
export class CreateOrderComponent implements OnInit {

  constructor(private salservice: SalService, private spinnerService: Ng4LoadingSpinnerService,
    private lookupService: LookupService, public globalHelper: GlobalHelper) { }

    

  PurchaseOrder = {
    CustomerID: 0,  
    CustomerName:'', 
    OrderAmount: 0,
    ProductName: '',
    OrderNo: '',
    InvoiceNo:'',
    SubTotalAmount: 0,
    PageAction:'',
    Remarks:'',
    CurrencyCode:'',
    SchoolID:0,
    BranchID:0,
  };

  
  GetCustomerName() {
   this.Reset();
    var ItemBO = {
      'ItemName': this.PurchaseOrder.CustomerName
    }
    this.lookupService.GetLookupsList('CustomerName', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.CustomerList = data.LookupItems;
      this.CustomerList.splice(0,1);

    });
  };
  CustomerList = [];
  GetCustomer() {
    this.lookupService.GetLookupsList('CustomerCurrency', '').subscribe((data: any) => {
      this.CustomerList = data.LookupItems;
    });
  }

  SelectedCustomerName(item){
    this.PurchaseOrder.CustomerID=item.ItemId;
    this.GetCustomerDetails();
  }
  GST = 100;
  IGST = 0;

  DisplayModel={
    CompanyName:'',
    Email:'',
    Mobile:'',
    GSTNO:'',
    Address1:'',
    Address2:'',
    City:'',
    StateName:'',
    CountryName:'',
    Zipcode:'',
    CurrencyCode:'',
    CustomerName:'',
  }


  GetCustomerDetails() {
    this.ItemModelList=[];
    this.CustomerTax=[];
    this.ProductModel.CurrencyCode='';   
    this.PurchaseOrder.CurrencyCode='';
    this.PurchaseOrder.PageAction='GETCUSTOMERDETAILS';
    this.spinnerService.show();
    this.salservice.GetCustomerDetails(JSON.stringify(this.PurchaseOrder)).subscribe((response: any) => {
     if(response.CustomerDetails!=null){
      this.GST = response.CustomerDetails.GST;
      this.IGST = response.CustomerDetails.IGST;
      this.DisplayModel.CompanyName=response.CustomerDetails.CompanyName;
      this.DisplayModel.Email=response.CustomerDetails.Email;
      this.DisplayModel.Mobile=response.CustomerDetails.Mobile;
      this.DisplayModel.Address1=response.CustomerDetails.Address1;
      this.DisplayModel.GSTNO=response.CustomerDetails.GSTNO;
      this.DisplayModel.Address2=response.CustomerDetails.Address2;
      this.DisplayModel.StateName=response.CustomerDetails.StateName;
      this.DisplayModel.CountryName=response.CustomerDetails.CountryName;
      this.DisplayModel.City=response.CustomerDetails.City;
      this.DisplayModel.Zipcode=response.CustomerDetails.Zipcode;
      this.DisplayModel.CustomerName=response.CustomerDetails.CustomerName;
      this.DisplayModel.CurrencyCode=response.CustomerDetails.CurrencyCode;
      this.ProductModel.CurrencyCode=response.CustomerDetails.CurrencyCode;
      this.PurchaseOrder.CurrencyCode=response.CustomerDetails.CurrencyCode;
      this.GetAllProducts();
     }
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
     
    });
  };

  ProductModel={
    PageAction:'', 
    CurrencyCode:'',
  }
  ProductList = [];  
  GetAllProducts() {
    this.ProductModel.PageAction='GETALLPRODUCTS';
    this.spinnerService.show();
    this.salservice.GetAllProducts(JSON.stringify(this.ProductModel)).subscribe((response: any) => {
      this.ProductList = response.ProductList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
      this.GetAllTotal();
    });
  };


  ItemModelList = [];
 
  FieldVaildation() {
    return this.ItemModelList.length == 0 || this.PurchaseOrder.CustomerID == 0;

  }

  Submitted = false;
  SaveSalOrder() {
    this.Submitted = true;
    if (!this.FieldVaildation()) {
      this.PurchaseOrder.PageAction='SAVESALORDER';
      this.Submitted = false;
      this.spinnerService.show();
      this.salservice.SaveSalOrder(JSON.stringify(this.ItemModelList), JSON.stringify(this.PurchaseOrder)).subscribe((data: any) => {
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
        if (data.webResponse.Status) {
          this.PurchaseOrder.OrderNo = data.OrderNo;
          this.PurchaseOrder.InvoiceNo = data.InvoiceNo; 
                
        }
      }
      );
    }

  }

  SaveSalInvoice() {
    this.Submitted = true;
    if (!this.FieldVaildation()) {
      this.PurchaseOrder.PageAction='SAVESALINVOICE';
      this.Submitted = false;
      this.spinnerService.show();
      this.salservice.SaveSalOrder(JSON.stringify(this.ItemModelList), JSON.stringify(this.PurchaseOrder)).subscribe((data: any) => {
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
        if (data.webResponse.Status) {
          this.PurchaseOrder.OrderNo = data.OrderNo;
          this.PurchaseOrder.InvoiceNo = data.InvoiceNo;                 
        }
      }
      );
    }

  }

  Reset() {
    this.PurchaseOrder.CustomerID = 0;   
    this.PurchaseOrder.Remarks='';
    this.PurchaseOrder.CurrencyCode='';
    this.PurchaseOrder.OrderNo = '';
    this.PurchaseOrder.InvoiceNo = '';
    this.ItemModelList = [];
    this.CustomerTax = [];
    this.SubTotalAmount = 0;
    this.PurchaseOrder.OrderAmount = 0;
    this.DisplayModel.Address1='';
    this.DisplayModel.Address2='';
    this.DisplayModel.City='';
    this.DisplayModel.CompanyName='';
    this.DisplayModel.CountryName='';
    this.DisplayModel.Email='';
    this.DisplayModel.GSTNO='';
    this.DisplayModel.Mobile='';
    this.DisplayModel.StateName='';
    this.DisplayModel.CustomerName='';
    this.DisplayModel.Zipcode='';
    this.DisplayModel.CurrencyCode='';
    this.ProductModel.CurrencyCode = '';
  };


  SelectedProduct($item) {
    var item =
    {
      ItemId: $item.ItemId,
      ProductID: $item.ProductID,
      ProductCode: $item.ProductCode,
      ProductName: $item.ProductName,
      ProductType: $item.ProductType,
      BillingCycleID:$item.BillingCycleID,
      BillingCycle: $item.BillingCycle,
      PriceType: $item.PriceType,
      Qty: 1,
      CurrencyCode:this.ProductModel.CurrencyCode,
      Price: $item.Price,
      TaxAmount: this.caluclatetax($item.Price * 1, this.GST == 0 && this.ProductModel.CurrencyCode!='INR' ? 0 : 18),
      Amount: $item.Price * 1,
    }


    if (!this.CheckIsExistProduct($item.ItemId)) {
      this.PurchaseOrder.ProductName = '';
      this.ItemModelList.push(item);
      this.GetAllTotal();
    }
  };

  GetProductTotal(item) {
    item.TaxAmount = this.GST == 0 && this.ProductModel.CurrencyCode!='INR' ? 0 : (item.Qty * item.Price * 18) / 100;
    item.Amount = item.Qty * item.Price;
    this.GetAllTotal();
  }

  CheckIsExistProduct(ProductID) {
    for (var i = 0; i < this.ItemModelList.length; i++) {
      if (this.ItemModelList[i].ItemId == ProductID) {
        alert('Product Already Exists...');
        return true;
      }
    }
    return false;
  }

  Remove(index) {
    this.ItemModelList.splice(index, 1);
    this.GetAllTotal();
  };

  caluclatetax(amount, rate) {
    return (amount * rate) / 100;
  }

  CustomerTax = [];
  SubTotalAmount = 0;
  GetAllTotal() {
    this.CustomerTax = [];
    var TotalAmount = 0;
    this.SubTotalAmount = 0;
    for (var i = 0; i < this.ItemModelList.length; i++) {
      TotalAmount = TotalAmount + this.ItemModelList[i].Price * this.ItemModelList[i].Qty;
    }

    this.SubTotalAmount = TotalAmount;
    if (this.GST == 0 && this.ProductModel.CurrencyCode!='INR') {
      var item = {
        'Name': '',
        'Amount': 0,
      }
      this.CustomerTax.push(item);
    }
    else if (this.GST == 0 && this.ProductModel.CurrencyCode=='INR') {
      var item = {
        'Name': 'CGST@9%',
        'Amount': this.caluclatetax(this.SubTotalAmount, 9),
      }
      this.CustomerTax.push(item);
      var item = {
        'Name': 'SGST@9%',
        'Amount': this.caluclatetax(this.SubTotalAmount, 9),
      }
      this.CustomerTax.push(item);
    }
    else if (this.IGST == 1) {
      var item = {
        'Name': 'CGST@9%',
        'Amount': this.caluclatetax(this.SubTotalAmount, 9),
      }
      this.CustomerTax.push(item);
      var item = {
        'Name': 'SGST@9%',
        'Amount': this.caluclatetax(this.SubTotalAmount, 9),
      }
      this.CustomerTax.push(item);
    }
    else {
      var item = {
        'Name': 'IGST@18%',
        'Amount': this.caluclatetax(this.SubTotalAmount, 18),
      }
      this.CustomerTax.push(item);
    }

    this.PurchaseOrder.SubTotalAmount = TotalAmount;
    for (var i = 0; i < this.CustomerTax.length; i++) {
      TotalAmount = TotalAmount + this.CustomerTax[i].Amount;
    }
    this.PurchaseOrder.OrderAmount = TotalAmount;
  }

  ngOnInit() {
    // this.GetCustomerName();
    this.GetAllSchool();
  }

  SchoolList: any;
  GetAllSchool() {   
    this.lookupService.GetLookupsList('School','').subscribe((data: any) => {
      this.SchoolList = data.LookupItems;

    });
  };
  BranchList: any;
  GetSchoolBranch() {  
    var item = {
      'SchoolID': this.PurchaseOrder.SchoolID
    }
    this.lookupService.GetLookupsList('TicketBranchSchool',JSON.stringify(item)).subscribe((data: any) => {
      this.BranchList = data.LookupItems;

    });
  };
  
 
}
